import type { PointerEvent as ReactPointerEvent } from "react";

export const PLAN_OBJECT_PAN = "c1-plan-object-pan";
export const PLAN_CANCEL_OBJECT_DRAG = "c1-plan-cancel-object-drag";
export type PlanObjectPanRequest = {
  pointerId: number;
  clientX: number;
  clientY: number;
  target: Element;
  select: () => void;
};

/** Let an unselected object's press pan the viewport, while retaining its click action. */
export function panUnselectedPlanObject(event: ReactPointerEvent, select: () => void): boolean {
  if (event.button !== 0) return false;
  const area = event.currentTarget.closest(".C1_drawingArea");
  if (!area) return false;
  if (event.pointerType !== "mouse" && area.getAttribute?.("data-c1-mobile-edit") !== "true") return false;
  const request = new CustomEvent<PlanObjectPanRequest>(PLAN_OBJECT_PAN, {
    cancelable: true,
    detail: {
      pointerId: event.pointerId, clientX: event.clientX, clientY: event.clientY,
      target: event.currentTarget, select,
    },
  });
  area.dispatchEvent(request);
  if (!request.defaultPrevented) return false;
  event.preventDefault();
  event.stopPropagation();
  return true;
}
